<div class="boxs3">
	<div style="width: 25%;padding: 10px;">
		<ng-select [items]="dailyUsageFilters" bindLabel="name" name="filter" placeholder="Select a Filter" (ngModelChange)="filterAllDailyDetails($event)" [(ngModel)]="selectedDailyUsageFilter" *ngIf="!isBattviewMobile" [clearable]="false">
		</ng-select>
	</div>
	<app-grid-v2 #grid id="DailyDetails" [columns]="gridColumns" [data]="gridData"></app-grid-v2>
</div>